import loadable from '@loadable/component'

export const ArticleVideo = loadable(() => import('./ArticleVideo'))

export default ArticleVideo
